export default __webpack_public_path__ + "static/media/bh-border.88a287b7.svg";